import React, { useRef, useState } from "react";

import entrantemejillonesImg from "../../images/entrante_mejillones-escabeche.png";
import primerplatosalmorejoImg from "../../images/primer-plato_salmorejo.png";
import segundoplatosopamariscoImg from "../../images/segundo-plato_sopa-marisco.png";
import postrecafeespecialImg from "../../images/postre_cafe-especial.png";

function SlideCard({ bg = "bg-[#f4f8fc]", children }) {
  return (
    <div className={`${bg} h-full p-6 rounded-lg shadow overflow-y-auto`}>
      {children}
    </div>
  );
}

export default function MenuTexturaNectarMiel() {
  const [index, setIndex] = useState(0);
  const touchStartX = useRef(null);
  const touchDeltaX = useRef(0);

  // Slides
  const slides = [
    {
      key: "entrante-mejillones-escabeche",
      content: (
        <SlideCard bg="bg-[#f4f8fc]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>ENTRANTE: MEJILLONES EN ESCABECHE</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={entrantemejillonesImg}
                alt="ENTRANTE: MEJILLONES EN ESCABECHE"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para dos personas:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- 1 lata de mejillones.</li>
              <li>- Limón al gusto.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ol className="text-justify list-decimal list-inside space-y-2">
              <li>Triturar los mejillones.</li>
              <li>Añadir una cucharada pequeña de escabeche.</li>
              <li>Añadir unas gotas de limón al gusto.</li>
              <li>Mezclar todos los ingredientes hasta conseguir una mezcla homogénea y sin grumos.</li>
              <li>Servir la mezcla en cucharas individuales intentando simular la textura original con el fin de conseguir una adaptación del plato apetecible.</li>
            </ol>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Nota:</p>
            <ul className="text-justify list-none space-y-2">
              <li>Si se necesita una textura menos espesa añadir más líquido del escabeche.</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
    {
      key: "primer-plato-salmorejo",
      content: (
        <SlideCard bg="bg-[#dfeaf7]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>PRIMER PLATO: SALMOREJO CORDOBÉS</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={primerplatosalmorejoImg}
                alt="PRIMER PLATO: SALMOREJO CORDOBÉS"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para dos personas:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- 1 kg de tomates maduros.</li>
              <li>- 150 g de pan.</li>
              <li>- 120 ml de aceite de oliva virgen extra.</li>
              <li>- 1 diente de ajo, pelado.</li>
              <li>- 1 cucharadita de sal (5 g).</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ol className="text-justify list-decimal list-inside space-y-2">
              <li>Pelar los tomates y corta en trozos pequeños.</li>
              <li>Batir los tomates durante unos 2-3 minutos.</li>
              <li>Añadir el resto de ingredientes y batir unos 2-3 minutos hasta conseguir una mezcla homogénea y sin grumos.</li>
              <li>Dejar enfriar la mezcla en la nevera durante 1-2 horas.</li>
            </ol>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Nota:</p>
            <ul className="text-justify list-none space-y-2">
              <li>Si necesitamos una textura más espesa podemos añadir más cantidad de pan.</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
    {
      key: "segundo-plato-sopa-marisco",
      content: (
        <SlideCard bg="bg-[#f4f8fc]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>SEGUNDO PLATO: SOPA DE MARISCO</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={segundoplatosopamariscoImg}
                alt="SEGUNDO PLATO: SOPA DE MARISCO"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para dos personas:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- 500 ml caldo de pescado (casero o envasado).</li>
              <li>- 1/2 kg de mejillones.</li>
              <li>- 10 Gambas peladas.</li>
              <li>- 160 g de fideos.</li>
              <li>- 1 tomate.</li>
              <li>- 2 dientes de ajo.</li>
              <li>- Pimentón picante.</li>
              <li>- Sal.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ol className="text-justify list-decimal list-inside space-y-2">
              <li>Freír los dientes de ajo con aceite de oliva y reservar.</li>
              <li>Hervir los mejillones con medio vaso de agua.</li>
              <li>Freír las gambas peladas y reservar.</li>
              <li>Pelar, cortar el tomate y triturarlo junto a los dientes de ajo con una batidora.</li>
              <li>Añadir la mezcla en una sartén junto a las gambas y los mejillones pelados y sofreír durante unos minutos.</li>
              <li>Añadir una cucharada de pimentón picante y sal.</li>
              <li>Añadir los fideos junto con el resto de ingredientes y el caldo de pescado y hervir durante 12-13 min.</li>
              <li>Triturar la ración obtenida hasta conseguir una mezcla homogénea y sin grumos.</li>
            </ol>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Nota:</p>
            <ul className="text-justify list-none space-y-2">
              <li>Para adaptar la consistencia del plato podemos utilizar más o menos caldo cuando estemos triturando la ración.</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
    {
      key: "postre-cafe-especial",
      content: (
        <SlideCard bg="bg-[#dfeaf7]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>POSTRE: CAFÉ ESPECIAL</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={postrecafeespecialImg}
                alt="POSTRE: CAFÉ ESPECIAL"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para una persona:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- 1 taza de café.</li>
              <li>- 1/2 taza de leche entera.</li>
              <li>- 2 cucharadas soperas de leche en polvo.</li>
              <li>- 2 cucharadas de cacao en polvo.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ol className="text-justify list-decimal list-inside space-y-2">
              <li>Añadir en un vaso o copa grande todos los ingredientes y remover con un espumadora de leche.</li>
              <li>Servir caliente o frío.</li>
            </ol>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Nota:</p>
            <ul className="text-justify list-none space-y-2">
              <li>Si se necesita una textura más espesa se puede añadir una curada sopera de leche condensada.</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
  ];

  const prev = () => setIndex((i) => Math.max(0, i - 1));
  const next = () => setIndex((i) => Math.min(slides.length - 1, i + 1));

  // Gestos táctiles
  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchDeltaX.current = 0;
  };
  const onTouchMove = (e) => {
    if (touchStartX.current == null) return;
    const currentX = e.touches[0].clientX;
    touchDeltaX.current = currentX - touchStartX.current;
  };
  const onTouchEnd = () => {
    const threshold = 50;
    if (touchDeltaX.current < -threshold) next();
    if (touchDeltaX.current > threshold) prev();
    touchStartX.current = null;
    touchDeltaX.current = 0;
  };

  // Teclado
  const onKeyDown = (e) => {
    if (e.key === "ArrowRight") next();
    if (e.key === "ArrowLeft") prev();
  };

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">
      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h5 className="font-bold text-center">Menú textura néctar-miel (sin espesante)</h5>
      </div>

      {/* Carrusel con altura fija */}
      <div
        className="relative overflow-hidden rounded-lg h-[520px] sm:h-[580px]"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        onKeyDown={onKeyDown}
        tabIndex={0}
        aria-roledescription="carousel"
        aria-label="Recetas de disfagia"
      >
        <div
          className="flex h-full transition-transform duration-300 ease-out"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {slides.map((slide) => (
            <div key={slide.key} className="min-w-full h-full px-0">
              {slide.content}
            </div>
          ))}
        </div>

        {/* Flechas */}
        <button
          type="button"
          onClick={prev}
          disabled={index === 0}
          aria-label="Anterior"
          className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-white/80 backdrop-blur px-3 py-2 shadow hover:bg-white disabled:opacity-40"
        >
          ←
        </button>
        <button
          type="button"
          onClick={next}
          disabled={index === slides.length - 1}
          aria-label="Siguiente"
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-white/80 backdrop-blur px-3 py-2 shadow hover:bg-white disabled:opacity-40"
        >
          →
        </button>

        {/* Indicadores */}
        <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-2">
          {slides.map((_, i) => (
            <span
              key={i}
              className={`h-2 w-2 rounded-full ${i === index ? "bg-gray-800" : "bg-gray-400"}`}
              aria-label={`Ir al slide ${i + 1}`}
            />
          ))}
        </div>
      </div>

      {/* Texto + descargable */}
      <div className="flex items-center">
        <p className="text-justify gap-4 mt-2 mb-4">
          Si desea obtener el descargable, pulse en el siguiente{" "}
          <a
            href="/docs/menus-adaptados-disfagia_menu-textura-nectar-miel.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            enlace
          </a>
          .
        </p>
      </div>

    </div>
  );
}